<!-- 主页面逻辑:这里全都是和活动相关的 -->
<template>
    <template v-if="ua.isMobile">
        <Header logo="apojj-y1kru" title="千里同风" desc="别岁经年·风月同天" />
        <div class="m-container">
            <button class="go heartbeat" v-click="{ btn_name: 'mashang' }" @click="handleGo"></button>
        </div>
    </template>
    <template v-else>
        <div class="nut-container">
            <img class="nut-img" src="https://g20.gsf.netease.com/1751978220260/png/2025qltf_pc_img_changtu.png" alt="">
            <button class="nut-go heartbeat" v-click="{ btn_name: 'mashang' }" @click="handleShowCode"></button>
            <Dialog v-model="dialog.code">
                <div class="code-wraper">
                    <QrcodeVue :size="300" value="https://h5.tx3.163.com/h5/tx3/20250709/box/" />
                    <span class="buy-tips">微信扫码前往购买</span>
                </div>
            </Dialog>
        </div>
    </template>
</template>
<script setup>
import { reactive } from 'vue';
import Header from '../components/Header.vue';
import { useGlobalState } from '../plugins/vue/store';
import QrcodeVue from 'qrcode.vue'
const dialog = reactive({
    code: false
})
const { ua } = useGlobalState()
function handleGo() {
    window.open('https://h5.tx3.163.com/h5/tx3/20250709/box/')
}

function handleShowCode() {
    // 展示code
    dialog.code = true
}
</script>
<style lang="scss" scoped>
.m-container {
    @include bg-img('2025qltf_h5_img_changtu');
    display: flex;
    justify-content: center;
    margin-top: 13.33vw;
}

.nut-container {
    // @include bg-img('2025qltf_pc_img_changtu');
    height: 11366px;
    min-width: 1920px;
    background-position: 50% 0;
    background-size: 100% auto;
    z-index: 1;
    display: flex;
    justify-content: center;
    position: relative;
}
.nut-img{
    width: 100%;
}
.nut-go {
    @include bg-img('btnqw_6546c547');
    width: 562px;
    height: 88px;
    top: 6350px;
    position: absolute;
}

.go {
    @include bg-img('btnqw_6546c547');
    top: 805vw;
}

.code-wraper {
    background-color: white;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    font-size: 9px;
}
.buy-tips{
    margin-top: 5px;
}
</style>